<template>
  <div class="inventoryList">
    <el-table
      :data="tableData"
      style="width: 100%; margin-bottom: 20px"
      v-loading="tableLoading"
    >
      <el-table-column
        min-width="200"
        align="center"
        :label="$t('devices.aps.storeName')"
      >
        <el-table-column min-width="200" align="center" prop="storeName">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="pageParams.storeName"
              @input="getList"
              size="small"
              placeholder=""
              clearable
            />
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="200"
        align="center"
        :label="$t('devices.inventory.Inventory Name')"
        prop="name"
      >
        <el-table-column min-width="200" align="center" prop="name">
          <template slot="header" slot-scope="scope"></template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="180"
        align="center"
        :label="$t('devices.inventory.operator')"
        prop="createUser"
      >
        <el-table-column min-width="180" align="center" prop="createUser">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="200"
        align="center"
        :label="$t('devices.inventory.state')"
        prop="stateName"
      >
        <el-table-column min-width="200" align="center" prop="stateName">
          <template slot="header" slot-scope="scope"></template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="180"
        align="center"
        :label="$t('devices.inventory.startTime')"
        prop="createTime"
      >
        <el-table-column min-width="180" align="center" prop="createTime">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        min-width="180"
        align="center"
        :label="$t('devices.inventory.endTime')"
        prop="updateTime"
      >
        <el-table-column min-width="180" align="center" prop="updateTime">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        min-width="120"
        :label="$t('devices.aps.remark')"
        prop="note"
      >
        <el-table-column align="center" min-width="120" prop="note">
          <template slot="header" slot-scope="scope"> </template>
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        fixed="right"
        :label="$t('devices.aps.action')"
        width="120"
      >
        <el-table-column align="center" width="120">
          <template slot-scope="{ row }">
            <div class="action-wrapper">
              <span
                class="icon icon-info"
                style="cursor: pointer"
                @click="checkSingleData(row)"
              >
                <i
                  class="el-icon-search"
                  :title="$t('devices.inventory.check')"
                ></i>
              </span>
              <span
                class="icon icon-info"
                v-if="row.state != 3603"
                @click="handelEnd(row)"
                style="margin-left: 15px; cursor: pointer"
              >
                <i
                  class="el-icon-switch-button"
                  :title="$t('devices.inventory.closeInventory')"
                ></i>
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <pagination :tableInfo="pageParams" @changePage="changePage" />

    <!-- EndInventory step2 -->
    <!-- append-to-body dialog in dialog -->
    <el-dialog
      :title="$t('devices.inventory.EndInventory')"
      :visible.sync="isVisibleEndDialog2"
      class="communication-records_dialog"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <end-inventory ref="endForm" :rowData="rowData"></end-inventory>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="isVisibleEndDialog2 = false"
          >{{ $t("devices.cancel") }}</el-button
        >
        <!-- @click="handelTransmitByAp" -->

        <el-button
          class="save-btn btn"
          size="small"
          type="primary"
          @click="handelEndSubmit"
          >{{ $t("devices.ok") }}</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看明细 -->
    <el-dialog
      :title="$t('devices.inventory.Inventory details')"
      :visible.sync="isVisibleDetailDialog"
      class="communication-records_dialog"
      width="90%"
      :close-on-click-modal="false"
      append-to-body
    >
      <inventory-detail
        ref="checkDetailWrap"
        :clickRow="clickRow"
      ></inventory-detail>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="cancel-btn btn"
          size="small"
          @click="isVisibleDetailDialog = false"
          >{{ $t("devices.cancel") }}</el-button
        >
        <el-button
          class="save-btn btn"
          size="small"
          @click="isVisibleDetailDialog = false"
          type="primary"
          >{{ $t("devices.ok") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagination from "@/components/pagination";
import EndInventory from "./EndInventory";
import InventoryDetail from "./InventoryDetail.vue";
import { inventoryInfoList, completeInventory } from "@/libs/api/inventory";

export default {
  components: {
    pagination,
    EndInventory,
    InventoryDetail,
  },
  props: {
    currentRow: {
      type: Object,
      require: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      clickRow: {},
      tableLoading: false,
      tableData: [],
      pageParams: {
        batchId: "",
        storeId: "",
        storeType: "",
        storeName: "",
        current: 1,
        size: 10,
      },
      isVisibleEndDialog2: false,
      rowData: {},
      loading: false,
      isVisibleDetailDialog: false,
    };
  },
  watch: {
    currentRow: {
      handler(val, oldVal) {
        console.log(val);
        this.getList();
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    // this.getStore();
    console.log(this.currentRow);
    // this.getList();
  },
  methods: {
    checkSingleData(row) {
      console.log(123);
      console.log(row);
      this.clickRow = row;
      this.isVisibleDetailDialog = true;
      // 查看单个门店明细
    },
    changePage() {
      this.getList();
    },
    getList() {
      console.log(123);
      const params = {
        batchId: this.currentRow ? this.currentRow.batchId : "",
      };
      inventoryInfoList(params).then((res) => {
        console.log(res);
        this.tableData = res.data.data.records;
      });
    },

    handelEnd(row) {
      this.rowData = row;
      // this.isVisibleEndDialog2 = true;
      this.handelEndSubmit();
    },
    async handelEndSubmit() {
      this.$confirm(this.$t("devices.inventory.ComfirmInfo"), {
        confirmButtonText: this.$t("taskLog.Comfirm"),
        cancelButtonText: this.$t("taskLog.Cancel"),
        type: "warning",
        center: true,
      }).then(async () => {
        try {
          // this.$refs.endForm.$refs["ruleForm"].validate(async (valid) => {
          // if (valid) {
          // const ruleForm =
          //   this.$refs && this.$refs.endForm && this.$refs.endForm.ruleForm
          //     ? this.$refs.endForm.ruleForm
          //     : {};
          const params = {
            // ...ruleForm,
            id: this.rowData.id,
          };

          this.loading = true;
          const { data } = await completeInventory(params);
          if (data.state === true) {
            this.isVisibleEndDialog2 = false;
            this.$message.success(this.$t("devices.operationSuccess"));
            this.getList();
          } else {
            this.$message.error(data.message);
          }
          this.loading = false;
          // } else {
          //   console.log("error submit!!");
          //   return false;
          // }
          // });
        } catch (err) {
          const { message } = err;
          this.$message.error(message);
          this.loading = false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-info {
  font-size: 19px;
}
.icon-info:before {
  content: "";
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 110px;
    height: 40px;
  }

  .btn {
    // border-radius: 10px;
  }
  .el-button.cancel-btn {
    background: #d4d4d4 !important;
    box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
    color: #626262;
  }
  .el-button.save-btn {
    background: #35b871 !important;
    box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
    color: #ffffff;
  }
}
.dialog-footer ::v-deep {
  text-align: center;
  .el-button {
    width: 110px;
    height: 40px;
    border: none;
  }
  .el-button.cancel-btn {
    background: #d4d4d4 !important;
    box-shadow: 0px 1px 15px 0px rgba(99, 99, 99, 0.23);
    color: #626262;
  }
  .el-button.save-btn {
    background: #35b871 !important;
    box-shadow: 0px 1px 15px 0px rgba(53, 184, 113, 0.55);
    color: #ffffff;
  }
}
</style>
